import { AddResourceToPatientPayload } from '_api/types';

const DefaultAddResourceToPatientSettings: AddResourceToPatientPayload = {
  contentId: 0,
  patientId: 0,
};

export default DefaultAddResourceToPatientSettings;
